export const NAMESPACE = {
  selectorPreloader: '.b-doctor-card__preloader',
  classNamePreloaderActive: 'b-doctor-card__preloader_active',
} as const
